import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "proposal-viewer__content"
}
const _hoisted_2 = { class: "proposal-viewer__content-title" }
const _hoisted_3 = { class: "proposal-viewer__content-description" }
const _hoisted_4 = { class: "proposal-viewer__content-location" }
const _hoisted_5 = { class: "proposal-viewer__content-details" }
const _hoisted_6 = { class: "proposal-viewer__content-duration-and-actions" }
const _hoisted_7 = { class: "proposal-viewer__content-duration" }
const _hoisted_8 = { class: "proposal-viewer__content-actions" }
const _hoisted_9 = {
  key: 0,
  class: "proposal-viewer__content-matrix"
}
const _hoisted_10 = {
  key: 1,
  class: "proposal-editor__content"
}
const _hoisted_11 = { class: "proposal-editor__column-left" }
const _hoisted_12 = { class: "proposal-editor__row-title" }
const _hoisted_13 = { class: "proposal-editor__row-details" }
const _hoisted_14 = { class: "proposal-editor__proposal-location-container" }
const _hoisted_15 = { class: "proposal-editor__proposal-duration-container" }
const _hoisted_16 = {
  key: 0,
  class: "proposal-editor__proposal-participants"
}
const _hoisted_17 = {
  key: 1,
  class: "proposal-editor__proposed-dates"
}
const _hoisted_18 = { class: "proposal-editor__row-actions" }
const _hoisted_19 = { class: "proposal-editor__column-right" }
const _hoisted_20 = { class: "proposal-editor__calendar-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_DurationIcon = _resolveComponent("DurationIcon")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_ProposalResponseMatrix = _resolveComponent("ProposalResponseMatrix")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcTextArea = _resolveComponent("NcTextArea")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcRadioGroupButton = _resolveComponent("NcRadioGroupButton")!
  const _component_NcRadioGroup = _resolveComponent("NcRadioGroup")!
  const _component_InviteesListSearch = _resolveComponent("InviteesListSearch")!
  const _component_ProposalParticipantItem = _resolveComponent("ProposalParticipantItem")!
  const _component_ProposalDateItem = _resolveComponent("ProposalDateItem")!
  const _component_PreviousSpanIcon = _resolveComponent("PreviousSpanIcon")!
  const _component_NextSpanIcon = _resolveComponent("NextSpanIcon")!
  const _component_ZoomInIcon = _resolveComponent("ZoomInIcon")!
  const _component_ZoomOutIcon = _resolveComponent("ZoomOutIcon")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_NcModal = _resolveComponent("NcModal")!
  const _component_NcDialog = _resolveComponent("NcDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.modalVisible)
      ? (_openBlock(), _createBlock(_component_NcModal, {
          key: 0,
          class: "proposal-modal__content",
          name: $options.modalTitle,
          title: $options.modalTitle,
          size: $options.modalSize,
          onClose: _cache[14] || (_cache[14] = ($event: any) => ($options.onModalClose()))
        }, {
          default: _withCtx(() => [
            ($data.modalMode === 'view')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString($data.selectedProposal?.title), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString($data.selectedProposal?.description || $options.t('calendar', 'No Description')), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_LocationIcon),
                    _createTextVNode(" " + _toDisplayString($data.selectedProposal?.location || $options.t('calendar', 'No Location')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_DurationIcon),
                        _createTextVNode(" " + _toDisplayString($data.selectedProposal?.duration ? $data.selectedProposal.duration + ' min' : '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_NcButton, {
                          variant: "tertiary",
                          title: $options.t('calendar', 'Edit this meeting proposal'),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onProposalModify()))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_EditIcon)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Edit')), 1)
                          ]),
                          _: 1
                        }, 8, ["title"]),
                        _createVNode(_component_NcButton, {
                          variant: "tertiary",
                          title: $options.t('calendar', 'Delete this meeting proposal'),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.onProposalDestroy($data.selectedProposal)))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_DeleteIcon)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Delete')), 1)
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ])
                    ])
                  ]),
                  ($data.selectedProposal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_ProposalResponseMatrix, {
                          mode: "organizer",
                          proposal: $data.selectedProposal,
                          timezoneId: $options.userTimezone,
                          onDateConvert: $options.onProposalConvert
                        }, null, 8, ["proposal", "timezoneId", "onDateConvert"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ($data.modalMode === 'create' || $data.modalMode === 'modify')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h2", null, _toDisplayString($options.modalEditLabel), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_NcTextField, {
                        modelValue: $data.selectedProposal.title,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.selectedProposal.title) = $event)),
                        class: "proposal-editor__proposal-title",
                        label: $options.t('calendar', 'Title')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_NcTextArea, {
                        modelValue: $data.selectedProposal.description,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.selectedProposal.description) = $event)),
                        class: "proposal-editor__proposal-description",
                        label: $options.t('calendar', 'Description')
                      }, null, 8, ["modelValue", "label"]),
                      _createElementVNode("div", _hoisted_14, [
                        (!$data.settingsStore.talkEnabled || !$options.modalEditLocationState)
                          ? (_openBlock(), _createBlock(_component_NcTextField, {
                              key: 0,
                              class: "proposal-editor__proposal-location",
                              label: $options.t('calendar', 'Location'),
                              modelValue: $data.selectedProposal.location
                            }, null, 8, ["label", "modelValue"]))
                          : _createCommentVNode("", true),
                        ($data.settingsStore.talkEnabled)
                          ? (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                              key: 1,
                              class: "proposal-editor__proposal-location-selector",
                              variant: "secondary",
                              modelValue: $options.modalEditLocationState,
                              "onUpdate:modelValue": $options.onProposalLocationTypeToggle
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.t('calendar', 'Add Talk conversation')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_NcTextField, {
                          modelValue: $data.selectedProposal.duration,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.selectedProposal.duration) = $event)),
                          class: "proposal-editor__proposal-duration",
                          label: $options.t('calendar', 'Duration'),
                          type: "number",
                          min: "1",
                          step: "1",
                          onInput: _cache[5] || (_cache[5] = ($event: any) => ($options.onProposalDurationChange($event)))
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_component_NcRadioGroup, {
                          modelValue: $data.selectedProposal.duration,
                          "onUpdate:modelValue": [
                            _cache[6] || (_cache[6] = ($event: any) => (($data.selectedProposal.duration) = $event)),
                            $options.onProposalDurationSuggestionChange
                          ],
                          class: "proposal-editor__proposal-duration-helpers",
                          label: $options.t('calendar', 'Duration suggestions'),
                          hideLabel: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([15, 30, 60, 90], (duration) => {
                              return _createVNode(_component_NcRadioGroupButton, {
                                key: duration,
                                label: $options.t('calendar', '{duration} min', { duration }),
                                value: duration
                              }, null, 8, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "onUpdate:modelValue"])
                      ]),
                      _createVNode(_component_InviteesListSearch, {
                        class: "proposal-editor__proposal-participants-selector",
                        alreadyInvitedEmails: $options.existingParticipantAddressess,
                        onAddAttendee: $options.onProposalParticipantAdd
                      }, null, 8, ["alreadyInvitedEmails", "onAddAttendee"]),
                      ($data.selectedProposal.participants.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("h6", null, _toDisplayString($options.t('calendar', 'Participants')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedProposal.participants, (participant, idx) => {
                              return (_openBlock(), _createBlock(_component_ProposalParticipantItem, {
                                key: idx,
                                proposalParticipant: participant,
                                onParticipantAttendance: ($event: any) => ($options.onProposalParticipantAttendance(participant.address, $event)),
                                onParticipantRemove: ($event: any) => ($options.onProposalParticipantRemove(participant.address))
                              }, null, 8, ["proposalParticipant", "onParticipantAttendance", "onParticipantRemove"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      ($data.selectedProposal.dates.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("h6", null, _toDisplayString($options.t('calendar', 'Selected times')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedProposal.dates, (entry, idx) => {
                              return (_openBlock(), _createBlock(_component_ProposalDateItem, {
                                key: idx,
                                proposalDate: entry,
                                timezoneId: $options.userTimezone,
                                onDateFocus: ($event: any) => ($options.onProposalDateFocus(entry)),
                                onDateRemove: ($event: any) => ($options.onProposalDateRemove(idx))
                              }, null, 8, ["proposalDate", "timezoneId", "onDateFocus", "onDateRemove"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_NcButton, {
                        class: "proposal-editor__save-button",
                        variant: "primary",
                        disabled: !$options.modalEditSaveState,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.onProposalSave()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.modalEditSaveLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      ($options.modalEditDestroyState)
                        ? (_openBlock(), _createBlock(_component_NcButton, {
                            key: 0,
                            variant: "secondary",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.onProposalDestroy($data.selectedProposal)))
                          }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                              _createTextVNode(" Delete ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.onCalendarFocusToday()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.t('calendar', 'Today')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        "aria-label": $options.t('calendar', 'Previous span'),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.onCalendarSpanPrevious()))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_PreviousSpanIcon)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]),
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        "aria-label": $options.t('calendar', 'Next span'),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.onCalendarSpanNext()))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_NextSpanIcon)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]),
                      _createElementVNode("h2", null, _toDisplayString($options.calendarDateRange), 1),
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        "aria-label": $options.t('calendar', 'Less days'),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.onCalendarSpanIncrease()))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ZoomInIcon)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]),
                      _createVNode(_component_NcButton, {
                        variant: "secondary",
                        "aria-label": $options.t('calendar', 'More days'),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.onCalendarSpanDecrease()))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ZoomOutIcon)
                        ]),
                        _: 1
                      }, 8, ["aria-label"])
                    ]),
                    _createVNode(_component_FullCalendar, {
                      ref: "proposalFullCalendar",
                      options: $options.calendarConfiguration,
                      class: "proposal-editor__calendar"
                    }, null, 8, ["options"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name", "title", "size"]))
      : _createCommentVNode("", true),
    _createVNode(_component_NcDialog, {
      open: $data.showDeleteDialog,
      name: $options.t('calendar', 'Delete proposal'),
      message: $options.deleteDialogMessage,
      buttons: $options.deleteDialogButtons,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ($data.showDeleteDialog = $event))
    }, null, 8, ["open", "name", "message", "buttons"]),
    _createVNode(_component_NcDialog, {
      open: $data.showConvertDialog,
      name: $options.t('calendar', 'Create meeting'),
      message: $options.convertDialogMessage,
      buttons: $options.convertDialogButtons,
      "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ($data.showConvertDialog = $event))
    }, null, 8, ["open", "name", "message", "buttons"])
  ]))
}